
  import React from "react"
  import Component from "/opt/build/repo/src/layouts/index.tsx"
  import data from "/opt/build/repo/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js